// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wGxz","colMin":"styles_colMin__3MmrH"};